<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
    role="img"
    class="text-vulcan dark:text-gold w-6 h-6"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
  >
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="m9 11l-4 4l4 4m-4-4h11a4 4 0 0 0 0-8h-1"
    ></path>
  </svg>
</template>

<script>
export default {
  name: "BackIcon",
  props: {
    width: {
      type: String,
      default: "w-[18px]",
    },
    height: {
      type: String,
      default: "h-[18px]",
    },
  },
};
</script>
